<template>
  <div class="checkout-builder-elements-modal">
    <div class="elements-container">
      <button
        v-for="element in allowedElements"
        class="element-cell"
        :key="element.type"
        @click="addElement(element.type)"
      >
        <div class="d-flex" v-if="Array.isArray(element.icon)">
          <bp-icon
            v-for="icon in element.icon"
            size="24"
            :key="icon"
            :icon="icon"
          />
        </div>
        <bp-icon v-else size="24" :icon="element.icon" />

        <div class="fs-14">{{ element.label }}</div>
      </button>
    </div>
  </div>
</template>

<script>
import elements from "./elements";
export default {
  props: {
    allow: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    allowedElements() {
      return elements.filter(e => this.allow.includes(e.type));
    }
  },
  methods: {
    addElement(type) {
      this.$emit("close");
      this.$emit("add-element", type);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout-builder-elements-modal {
  .elements-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 24px 0;
    gap: 16px;
  }

  .element-cell {
    gap: 12px;
    padding: 12px;
    display: flex;
    user-select: none;
    border-radius: 12px;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    background: var(--bg-1);
    border: 1px dashed var(--indigo);
  }
}
</style>
